<div class="dialog-padding">
  <h1 id="alertDialog-title-{{ data.title | camelCase }}" mat-dialog-title>
    <mat-icon *ngIf="data.svgIcon" [svgIcon]="data.svgIcon"></mat-icon>
    {{ data.title }}
  </h1>
  <p id="alertDialog-text-message" mat-dialog-content [innerHtml]="data.message | safeHtml"></p>
  <ng-container *ngIf="data.links">
    <p *ngFor="let link of data.links">
      <a (click)="link.handler()" [innerHtml]="link.text | safeHtml"></a>
    </p>
  </ng-container>
  <div mat-dialog-actions align="end">
    <ng-container *ngIf="!data.buttons; else customButtons">
      <button id="alertDialog-button-ok" mat-raised-button color="primary" (click)="confirm()">OK</button>
    </ng-container>
    <ng-template #customButtons>
      <button id="alertDialog-button-{{ button.text | camelCase }}" *ngFor="let button of data.buttons" mat-stroked-button color="primary" (click)="button.handler()">
        {{ button.text }}
      </button>
    </ng-template>
  </div>
</div>
